"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getByteLength = void 0;
function getByteLength(str) {
    var result = str.length;
    for (var i = result - 1; i >= 0; i--) {
        var code = str.charCodeAt(i);
        if (code > 0x7f && code <= 0x7ff) {
            result++;
        }
        else if (code > 0x7ff && code < 0xffff) {
            result += 2;
        }
        if (code >= 0xDC00 && code <= 0xDFFF) {
            i--;
        }
    }
    return result;
}
exports.getByteLength = getByteLength;
